import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { getColorVars, getDomain } from '../../../utils/functions';
import Barcode from 'react-barcode';
import { useMediaQuery } from 'react-responsive';

import { Customer } from '../../../types/customer';
import Button from '../../../components/Button';
import rukaLogo from '../../../components/Navigation/ruka-logo-ski-resort.png';
import rukaLoyaltyLogo from './ruka-loyalty-card.svg';
import pyhaLogo from '../../../components/Navigation/pyha-logo.svg';
import pyhaLoyaltyLogo from './pyha-loyalty-card.svg';
import closeIcon from './icon-close.svg';

interface Props {
  loyaltyModalIsOpen: boolean;
  setLoyaltyModalIsOpen: (isOpen: boolean) => void;
  customer: Customer;
  barcode: string;
}

const LoyaltyCard: React.FC<Props> = (props: Props): JSX.Element => {
  const domain = getDomain();
  const { bgColor } = getColorVars();
  const { t } = useTranslation(['profile_page']);

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  const isSmallScreen = useMediaQuery({ query: '(max-width: 374px)' });
  // Make the barcode smaller for narrow screens so it doesn't overflow.
  const barcodeWidth = isSmallScreen ? 1.8 : 2;

  let siteLogo, loyaltyLogo;

  if (domain === 'ruka') {
    siteLogo = rukaLogo;
    loyaltyLogo = rukaLoyaltyLogo;
  } else {
    siteLogo = pyhaLogo;
    loyaltyLogo = pyhaLoyaltyLogo;
  }

  return (
    <Modal
      isOpen={props.loyaltyModalIsOpen}
      style={{
        content: {
          maxWidth: '450px',
          maxHeight: isTabletOrMobile ? '650px' : '850px',
          width: '100%',
          padding: '0',
          top: '90px',
          transform: 'translate(-50%, -5%)',
          right: '50%',
          left: '50%',
          backgroundColor: '#2a2e4b',
          border: 'none',
        },
      }}
      onRequestClose={() => props.setLoyaltyModalIsOpen(false)}
    >
      <div className='h-[85%]'>
        <div className='flex justify-end py-2'>
          <Button
            variant='textonly'
            onClick={() => props.setLoyaltyModalIsOpen(false)}
          >
            <img src={closeIcon} alt={t('Close loyalty card') ?? 'Close'} />
          </Button>
        </div>

        <div className={`flex flex-col h-full ${bgColor}`}>
          <div className='flex flex-row justify-between p-4 items-center'>
            <img src={siteLogo} alt='Logo' className='h-16 w-auto' />
            <p className='text-white font-futura font-bold tracking-[0.175em]'>
              {props.barcode}
            </p>
          </div>

          <img
            src={loyaltyLogo}
            alt='Loyalty logo'
            className='w-10/12 mx-auto mt-2 mb-8 h-28'
          />

          <p className='mb-8 text-lg text-white text-center font-futura uppercase'>
            {props.customer.givenName} {props.customer.surname}
          </p>

          <div className='mx-auto mt-auto mb-8 flex flex-col justify-center'>
            <p className='text-xl text-white text-center font-futura uppercase mb-8'>
              {t('Loyalty member')}
            </p>

            <Barcode
              value={props.barcode}
              format='EAN13'
              width={barcodeWidth}
              displayValue={false}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LoyaltyCard;
